var exports = {
  "k": "ChatSettingsTabInline.module__container___U2lrNF",
};

module.exports = exports;
